import { useCallback, useRef } from 'react';

// The editors already block browser navigation while a form is dirty
// (NavigationBlocker), but "Back to View", switching sections while editing,
// the pager and the phone accordion all unmount the editor WITHOUT a
// navigation, so the edits vanished with no warning. The editors report
// their dirty state through onDirtyChange; the page asks confirmLeave()
// before any of those actions. Same wording as NavigationBlocker.
export const UNSAVED_MESSAGE = 'You have unsaved changes. Are you sure you want to leave?';

export default function useUnsavedGuard() {
  const dirty = useRef(false);
  const onDirtyChange = useCallback((isDirty) => {
    dirty.current = !!isDirty;
  }, []);
  // True when leaving is fine (nothing unsaved, or the person confirmed).
  const confirmLeave = useCallback(() => {
    if (!dirty.current) return true;
    const ok = typeof window !== 'undefined' && typeof window.confirm === 'function'
      ? window.confirm(UNSAVED_MESSAGE)
      : true;
    if (ok) dirty.current = false;
    return ok;
  }, []);
  const reset = useCallback(() => {
    dirty.current = false;
  }, []);
  return { onDirtyChange, confirmLeave, reset };
}
